import React from "react";
import { connect, ConnectedProps } from "react-redux";
import { chooseTreasure } from "../../../../store/actions/labyrinth";

import { treasures } from "../../../../assets/images/treasures";

interface IProps {
  generalId: number;
  treasureName: string;
  treasureInterval?: {min: number, max: number};
  fixedGain?: string;
  treasureCode: string;
  imageCode: number;
  iconName?: string;
  disabled?: boolean;
}

const mapDispatchToState = (dispatch: any) => ({
  chooseTreasureDispatch:
    (treasure: string, generalId: number) => dispatch(chooseTreasure(treasure, generalId))
});

const connector = connect(null, mapDispatchToState);

const TreasureBox = ({
  generalId,
  treasureName,
  treasureInterval,
  fixedGain,
  treasureCode,
  imageCode,
  iconName,
  disabled,
  chooseTreasureDispatch
}: IProps & ConnectedProps<typeof connector>) => (
  <div className="col-xs-6 col-sm-4">
    <div className={`person no-min-height match-height ${disabled ? "disabled" : ""}`}>
      <img src={treasures[`treasure${imageCode}`]} alt=""/>
      <h3 className="name">{treasureName}</h3>
      <p>
        <small className="positive">
          {fixedGain}
          {treasureInterval && `Gain: ${treasureInterval.min} - ${treasureInterval.max}`}
          {iconName && <i className={`icon icon-${iconName} align-sub`}/>}
        </small>
      </p>
      <a href="#"
         className="btn btn-blank"
         onClick={() => disabled || chooseTreasureDispatch(treasureCode, generalId)}
      >
        Choose
      </a>
    </div>
  </div>
)

export default connector(TreasureBox);
